export const defaultStyle = {
    mainMobilUlLI:"mainMobilUlLI",
    mainMobilUlBtn:"mainMobilUlBtn",
    mainMobilUlLIink:"mainMobilUlLIink",
    mainMobilUlSUbmenu:"mainMobilUlSUbmenu",
    mainMobiSUbmenuDiv:"mainMobiSUbmenuDiv",
    mainMobiSUbmenuSubWrap:"mainMobiSUbmenuSubWrap overflow-hidden",
    mainMobiSUbmSubWrapIn:"mainMobiSUbmSubWrapIn",
    mainMobiSUbmenuSubIcon:"mainMobiSUbmenuSubIcon",

}